import React, { Component } from 'react';
import FontAwesomeIcon from '@fortawesome/react-fontawesome';

import UsersApi from 'apis/Users';
import { extractQueryParams } from 'utils/url';
import Loading from 'utils/Loading';

import {
  setContactDetails,
  setToken,
  setUserId,
  setRole,
  setDashboardMetricObject,
  setBusinessId,
  setConfirmationGracePeriod,
  setConfirmed,
  setSessionTimeOut,
  setUserData,
} from 'constants/localStorageManager';
import { TRIAL_SIGNUP_ROUTES, ONBOARDING_ROUTES } from 'constants/Routes';
import LandingPageHeader from '../LandingPage/Header';

class UserEmailConfirmation extends Component {
  constructor() {
    super();

    this.state = {
      isInvalidToken: false,
    };
  }

  componentDidMount() {
    this.getParams();
  }

  getParams = () => {
    const { location } = this.props;
    const { search } = location;

    const queryParams = extractQueryParams(search.replace('?', ''));
    this.validateToken(queryParams);
  };

  validateToken = emailToken => {
    UsersApi.confirmEmail(emailToken)
      .then(response => {
        const { data, headers } = response;
        const token = headers.authorization;
        setToken(token);
        setSessionTimeOut();
        this.handleRedirect(data);
      })
      .catch(({ response }) => {
        const errorText =
          (response && response.data && response.data.confirmation_token) ||
          'is invalid';
        this.setState({ isInvalidToken: true, errorText });
      });
  };

  handleRedirect = data => {
    const { history } = this.props;
    const { dashboard } = data;
    if (!dashboard) {
      setContactDetails(data);
      history.push(TRIAL_SIGNUP_ROUTES.BUSINESS_DETAILS);
    } else {
      const {
        id,
        business,
        role,
        dashboard,
        confirmation_grace_period,
        confirmed,
      } = data;
      setUserData(data);
      setUserId(id);
      setBusinessId(business.id);
      setRole(role);
      setDashboardMetricObject(dashboard);
      setConfirmationGracePeriod(confirmation_grace_period);
      setConfirmed(confirmed);

      const pushUrl = ONBOARDING_ROUTES.STEP_ONE;
      history.push(pushUrl);
    }
  };

  render() {
    const { isInvalidToken, errorText } = this.state;

    if (isInvalidToken) {
      return (
        <div>
          {/* <LandingPageHeader /> */}
          <div className="d-flex justify-content-center">
            <div className="col-md-4 offset-md-4 m-5 pb-3 border">
              <div className="mt-3 text-center text-danger">
                <div className="mb-3">
                  <FontAwesomeIcon icon="exclamation-triangle" size="3x" />
                </div>
                Email confirmation token {errorText}.
              </div>
            </div>
          </div>
        </div>
      );
    }

    return (
      <div>
        <LandingPageHeader />
        <div className="container">
          <Loading title="Verifying email" />
        </div>
      </div>
    );
  }
}

export default UserEmailConfirmation;



// WEBPACK FOOTER //
// ./src/components/users/EmailConfirmation.js